import { initializeApp } from "firebase/app";
import { getFirestore} from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBP-vuE6fjMNL02ljFZ4V2SpaQp6PTrsg8",
  authDomain: "aldolo.firebaseapp.com",
  projectId: "aldolo",
  storageBucket: "aldolo.appspot.com",
  messagingSenderId: "670680597718",
  appId: "1:670680597718:web:136f625c3b28646cc6b577",
  measurementId: "G-GRQFZL4Y9F"
};
// const analytics = getAnalytics(app);

const app = initializeApp(firebaseConfig);
export const db= getFirestore(app);



// https://github.com/aldolo49